import sanityClient from '@sanity/client'

export default sanityClient ({
    projectId: "lsccpe3p",
    dataset: "production"
})